import React, { useState } from 'react';
import ProductCard from './ProductCard';
import { featuredProducts, categories } from '../data/mock';
import { Filter } from 'lucide-react';
import { Button } from './ui/button';

const ProductsSection = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [sortBy, setSortBy] = useState('commission');

  const filteredProducts = featuredProducts
    .filter(product => selectedCategory === 'All' || product.category === selectedCategory)
    .sort((a, b) => {
      if (sortBy === 'commission') return b.commissionAmount - a.commissionAmount;
      if (sortBy === 'conversion') return parseFloat(b.conversionRate) - parseFloat(a.conversionRate);
      if (sortBy === 'rating') return b.rating - a.rating;
      return 0;
    });

  return (
    <section id="products" className="py-20 px-4 bg-gray-50">
      <div className="container mx-auto max-w-7xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Top Converting Products
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Hand-picked products with proven track records, high commissions, and excellent conversion rates.
            Start promoting today and earn while you sleep.
          </p>
        </div>

        {/* Filters */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
          <div className="flex items-center space-x-2">
            <Filter className="w-5 h-5 text-gray-600" />
            <span className="text-sm font-semibold text-gray-700">Filter by:</span>
            <div className="flex flex-wrap gap-2">
              <Button
                variant={selectedCategory === 'All' ? 'default' : 'outline'}
                size="sm"
                onClick={() => setSelectedCategory('All')}
                className={selectedCategory === 'All' ? 'bg-emerald-600 hover:bg-emerald-700' : ''}
              >
                All Products
              </Button>
              <Button
                variant={selectedCategory === 'Course' ? 'default' : 'outline'}
                size="sm"
                onClick={() => setSelectedCategory('Course')}
                className={selectedCategory === 'Course' ? 'bg-emerald-600 hover:bg-emerald-700' : ''}
              >
                Courses
              </Button>
              <Button
                variant={selectedCategory === 'Software' ? 'default' : 'outline'}
                size="sm"
                onClick={() => setSelectedCategory('Software')}
                className={selectedCategory === 'Software' ? 'bg-emerald-600 hover:bg-emerald-700' : ''}
              >
                Software
              </Button>
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <span className="text-sm font-semibold text-gray-700">Sort by:</span>
            <select 
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            >
              <option value="commission">Highest Commission</option>
              <option value="conversion">Best Conversion Rate</option>
              <option value="rating">Top Rated</option>
            </select>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            Want access to all 150+ high-converting products?
          </p>
          <Button 
            onClick={() => document.getElementById('email-capture').scrollIntoView({ behavior: 'smooth' })}
            size="lg"
            className="bg-emerald-600 hover:bg-emerald-700 text-white px-8"
          >
            Get Full Product List
          </Button>
        </div>
      </div>
    </section>
  );
};
export default ProductsSection;
